import styles from "./IntegrationCard.module.scss"
import {IntegrationDetails} from "./IntegrationDetails"
import {ModelPlatform} from "../../api/enum/ModelPlatform"

export const integrationDetailsList: IntegrationDetails[] = [
    {
        platform: ModelPlatform.OPEN_AI,
        className: styles.openAi,
        iconSrc: "/openai.svg",
        path: "open-ai",
        apiKeysUrl: "https://platform.openai.com/account/api-keys",
    },
    {
        platform: ModelPlatform.ANTHROPIC,
        className: styles.anthropic,
        iconSrc: "/anthropic.svg",
        path: "anthropic",
        apiKeysUrl: "https://console.anthropic.com/settings/keys",
    },
    {
        platform: ModelPlatform.GOOGLE_AI,
        className: styles.googleAi,
        iconSrc: "/google-cloud.svg",
        path: "google-ai",
        apiKeysUrl: "https://aistudio.google.com/app/apikey",
    },
    {
        platform: ModelPlatform.GROQ_CLOUD,
        className: styles.groqCloud,
        iconSrc: "/groq.svg",
        path: "groq-cloud",
        apiKeysUrl: "https://console.groq.com/keys",
    },
    {
        platform: ModelPlatform.TOGETHER,
        className: styles.together,
        iconSrc: "/together.svg",
        path: "together",
        apiKeysUrl: "https://api.together.ai/settings/api-keys",
    },
]
